import type { Profile, ProfileRequest } from "@shyne/shared/api";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/lib/store";
import { profileChanged } from "@/lib/store/auth.slice";
import {
    fetchCurrentUser,
    saveCurrentUser,
    uploadAvatar,
} from "./account.slice";

export function useAccountSettings() {
    const dispatch = useAppDispatch();
    const { data: user, loading, saving, uploadingAvatar } = useAppSelector((s) => s.account);

    useEffect(() => {
        const reading = dispatch(fetchCurrentUser());
        return () => reading.abort();
    }, [dispatch]);

    const shown = (profile: Profile): Profile => {
        dispatch(profileChanged(profile));
        return profile;
    };

    const handleSave = async (changes: ProfileRequest): Promise<Profile> => shown(await dispatch(saveCurrentUser(changes)).unwrap());

    const handleAvatarUpload = async (file: File): Promise<Profile> => shown(await dispatch(uploadAvatar(file)).unwrap());

    return { user, loading, saving, uploadingAvatar, handleSave, handleAvatarUpload };
}
